import { Card, Fonts } from "@snapchat/snap-design-system";
import { type FC, useCallback } from "react";
import { ActionModal } from "../../common/components/ActionModal";
import { modalStyle, modalContainerStyle, headerStyle, listContainer } from "../../common/styles";
import { AffectedGroupsContainer } from "../container/AffectedGroupsContainer";
import { type ViewSourceModel } from "../models";

interface DeleteLensSourceModalProps {
    onDeleteLensSource: (lensSource: ViewSourceModel[]) => Promise<unknown>;
    lensSource: ViewSourceModel | null;
    onCancel: () => void;
    visible: boolean;
    deleting: boolean;
}

export const DeleteLensSourceModal: FC<DeleteLensSourceModalProps> = ({
    visible,
    deleting,
    lensSource,
    onCancel,
    onDeleteLensSource,
}) => {
    const handleDelete = useCallback(() => {
        if (!lensSource) return;
        onDeleteLensSource([lensSource])
            .catch(console.info)
            .finally(() => onCancel());
    }, [lensSource, onCancel, onDeleteLensSource]);

    return (
        <ActionModal
            padBody={false}
            visible={visible}
            onCancel={onCancel}
            className={modalStyle}
            onAction={handleDelete}
            actionText={"Delete Lens Source"}
            isActionButtonPending={deleting}
            isActionButtonDisabled={deleting}
            isCancelButtonDisabled={deleting}
            shouldAddKeyEvent={!deleting}
        >
            <Card
                padBody={false}
                titleBorder={false}
                titleStyle={Fonts.Heading.H500}
                title={"Delete Lens Source?"}
                className={modalContainerStyle}
            >
                <Card.Section className={headerStyle}>
                    Removing this Lens Source will affect the following lens groups
                </Card.Section>
                <Card.Section className={listContainer} padBody={false}>
                    <AffectedGroupsContainer lensSourceId={lensSource?.id ?? ""} />
                </Card.Section>
            </Card>
        </ActionModal>
    );
};
